export default __webpack_public_path__ + "static/media/PRIMInfo.76210860.md";